import { ReactComponent as Google } from "./../../assets/images/Logo/Google.svg";
import { ReactComponent as Facebook } from "./../../assets/images/Logo/Facebook.svg";
import GetUrl from "../../hooks/GetUrl";
import styles from "./styles.module.scss";

const RenderSocial = () => {
    return (
        <div className={styles.social}>
            <button
                onClick={() => {
                    const path = GetUrl();
                    window.parent.postMessage("googleAuth", path);
                }}
            >
                <Google />
            </button>

            <button>
                <Facebook />
            </button>
        </div>
    );
};

export default RenderSocial;
